<template>
  <div class="level-indicator m-0 p-0"
       :class="`level-indicator-with-${langLevelCount}`"
  >
    <span
      :class="`indicator indicator-${type} ${type==='step' ? `active-level-${level}` : ''}`"
      :style="`border-bottom-color:${indicatorColor};left:${type==='step'?'':( level > 95 ? (level-7):(level-3))+'%'}`"
    />
    <template v-if="distLangLevel">
      <small
        v-for="distlang,distIndex in distLangLevel"
        :key="distIndex"
        class="lang-level"
        :class="`active-level-${distIndex} ${type==='step' ? 'text-light lang-level-sl' : 'text-dark lang-level-rp'}`"
      >
        {{ distLangLevel[distIndex].label }}
      </small>
    </template>
    <template v-else>
      <small
        v-for="lang, index in cefrLangLevel"
        :key="index"
        class="lang-level"
        :class="`active-level-${index} ${type==='step' ? 'text-light lang-level-sl' : 'text-dark lang-level-rp'}`"
      >
        {{ lang.label }}
      </small>
    </template>
    <div
      v-if="type!='step'"
      style="margin-top:-8px"
      class="w-100 text-center"
    >
      {{ level }}%
    </div>

    <ul
      class="swatch"
      :style="`--swatch-gradient: ${swatchBackgroundGradient}`"
    />
  </div>
</template>

<script>
import {
  checkSettings,
} from '@/utils/visibilitySettings'
import { cefrLangLevel, LANG_LEVELS } from '@/const/langLevel'

export default {
  props: {
    level: {
      type: [String, Number],
      required: true,
    },
    type: {
      type: String,
      default: 'step',
    },
    indicatorColor: {
      type: String,
      default: 'white',
    },
  },
  data() {
    return {
      lang_levels: LANG_LEVELS,
      cefrLangLevel,
    }
  },
  computed: {
    distLangLevel() {
      const distSetting = this.$store.state.appConfig?.districtInfo?.user_meta
      const schoolSetting = this.$store.state.appConfig?.schoolInfo?.user_meta

      const distLangLevelSetting = checkSettings('lang_level_indicator', schoolSetting, distSetting)?.value
      return JSON.parse(distLangLevelSetting) && null
    },
    langLevelCount() {
      return this.distLangLevel ? Object.entries(this.distLangLevel).length : Object.entries(this.cefrLangLevel).length
    },
    swatchBackgroundGradient() {
      const colors = [
        '#81C784', // Light Green
        '#66BB6A', // Moderate Green
        '#43A047', // Leaf Green
        '#388E3C', // Dark Green
        '#2E7D32', // Final Dark Green
        '#1B5E20', // Extra Dark Green
      ]

      const count = this.langLevelCount
      const segmentWidth = 100 / count
      const gapWidth = 1 // 1% gap between segments

      const gradientStops = []

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < count; i++) {
        const color = colors[i] || colors[colors.length - 1] // Use last color if we run out
        const startPos = i * segmentWidth
        const endPos = (i + 1) * segmentWidth - gapWidth
        const gapEnd = (i + 1) * segmentWidth

        gradientStops.push(`${color} ${startPos}%`)
        gradientStops.push(`${color} ${endPos}%`)

        if (i < count - 1) {
          gradientStops.push(`transparent ${endPos}%`)
          gradientStops.push(`transparent ${gapEnd}%`)
        }
      }

      return `linear-gradient(90deg, ${gradientStops.join(', ')})`
    },
  },
}
</script>

<style scoped lang="scss">
.swatch {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: block;
  position: relative;
}
.level-indicator {
  position: relative;
  height: 10px;
}
.indicator {
  position: absolute;
  z-index: 10;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  border-radius: 6px;
  top: 6px;
}

.indicator-percentage{
  top: 24px !important;
}

.swatch::before {
  content: "";
  width: 100%;
  height: 12px;
  outline: 0px solid #000;
  border: 1px solid #fff;
  position: absolute;
  left: 0;
  border-radius: 10px;
  background-image: var(--swatch-gradient);
}

.swatch__elem {
  margin: 0;
  padding: 0;
  outline: 0px solid #c00;
  float: left;
  padding-left: 5px;

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.lang-level {
  position: absolute;
  /* margin-left: -2px; */
  z-index: 10;
  mix-blend-mode: difference !important;
}
.lang-level-rp {
  top: 28px;
}
.lang-level-sl {
  top: 15px;
}

.level-indicator-with-4 {
  width: 150px;
  .active-level-1, .active-level-A1 {
    left: 8%;
  }
  .active-level-2, .active-level-A2 {
    left: 30%;
  }
  .active-level-3, .active-level-B1 {
    left: 55%;
  }
  .active-level-4, .active-level-B2 {
    left: 81%;
  }
}

.level-indicator-with-6 {
  width: 150px;
  .active-level-1, .active-level-A1 {
    left: 5%;
  }
  .active-level-2, .active-level-A2 {
    left: 19.5%;
  }
  .active-level-3, .active-level-B1 {
    left: 38%;
  }
  .active-level-4, .active-level-B2 {
    left: 56%;
  }

  .active-level-5, .active-level-C1 {
    left: 70%;
  }

  .active-level-6, .active-level-C2 {
    left: 88%;
  }
}
</style>
